export default __webpack_public_path__ + "static/media/plus-circle-light.c6612558.svg";